
<div class="rec-container ">
  <h2>Search Recorded Land Plans by</h2>
  <form (ngSubmit)="onSubmit($event)" #f="ngForm">

    <div class="bp-container">
      <app-book-page [bookType]="bookType"></app-book-page>
    </div>

      <!--<div style="border:solid;border-width:2px;padding:10px;border-color:red;">-->
    <div>
        Plans recorded in Deeds Books (Deed Books 1 - 246) must be searched for in the Land Record 1962 to NOW search.<br/><br/>
      Plans with a recorded date of 1/1/1840 have an indeterminate recording date at this time.
    </div>

    <button class="btn btn-default" type="submit">
      SEARCH
    </button>
  </form>
</div>



